/// <reference path="../../../scripts/typings/angularjs/angular.d.ts" />
var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            //"use strict";
            var AngularRegisterHelper = /** @class */ (function () {
                function AngularRegisterHelper() {
                }
                AngularRegisterHelper.registerService = function (moduleName, componentName, componentClass) {
                    angular.module(moduleName).service(componentName, componentClass);
                };
                AngularRegisterHelper.registerConstant = function (moduleName, componentName, componentClass) {
                    console.log("[NgAppRegisterHelper] register constant : %s for module: %s", componentName, moduleName);
                    angular.module(moduleName).constant(componentName, componentClass);
                };
                AngularRegisterHelper.registerController = function (moduleName, componentName, componentClass) {
                    console.log("[NgAppRegisterHelper] register controller: %s for module: %s", componentName, moduleName);
                    angular.module(moduleName).controller(componentName, componentClass);
                };
                AngularRegisterHelper.registerDirective = function (moduleName, componentName, componentClass) {
                    console.log("[NgAppRegisterHelper] register directive: %s for module: %s", componentName, moduleName);
                    angular.module(moduleName).directive(componentName, componentClass);
                };
                AngularRegisterHelper.registerComponent = function (moduleName, componentName, componentClass) {
                    console.log("[NgAppRegisterHelper] register component: %s for module: %s", componentName, moduleName);
                    angular.module(moduleName).component(componentName, componentClass);
                };
                return AngularRegisterHelper;
            }());
            Helpers.AngularRegisterHelper = AngularRegisterHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=angularregisterhelper.js.map